import { ConfirmCancelButtons } from "@smartrr/shared/customerPortal/components/ConfirmCancelButtons";
import React from "react";

import { useVariantEnablementForSellingPlanId } from "@customer-app/state/reducers/sellingPlanGroups";

import { VariantSelector } from "./libs/components/VariantSelector";
import { ISelectorProps } from "./libs/types";

export const Selector = ({
  purchasable,
  isLoading,
  onCancelHandler,
  onSubmitHandler,
  sellingPlanId,
  options = {
    includeAddons: false,
    includeTrending: false,
  },
  showConfirmState,
  ...props
}: ISelectorProps) => {
  const enabledVariantOptions = useVariantEnablementForSellingPlanId(
    purchasable!,
    sellingPlanId,
    options.includeAddons,
    options.includeTrending
  );

  return (
    <React.Fragment>
      <VariantSelector
        purchasable={purchasable!}
        isLoading={isLoading}
        enabledVariantOptions={enabledVariantOptions}
        {...options}
        {...props}
      />
      <ConfirmCancelButtons
        onCancel={onCancelHandler}
        onConfirm={() => onSubmitHandler(enabledVariantOptions)}
        disabled={isLoading}
        isLoading={isLoading}
        showConfirmButton={!!purchasable}
        confirmTextOverride={options.confirmTextOverride ?? "general.confirmBtn"}
        cancelTextOverride={options.cancelTextOverride}
        showConfirmState={showConfirmState}
      />
    </React.Fragment>
  );
};
